import { __decorate, __metadata } from "tslib";
import { ApiProperty } from '@nestjs/swagger';
import { Expose } from 'class-transformer';
import { IsEmail } from 'class-validator';
import { LengthWithLVS } from '@goparrot/common';
export class AuthByEmailRequestDto {
}
__decorate([
    ApiProperty({ type: () => String }),
    Expose({ groups: ['login_email'] }),
    IsEmail({}, { groups: ['login_email'] }),
    __metadata("design:type", String)
], AuthByEmailRequestDto.prototype, "email", void 0);
__decorate([
    ApiProperty({ type: () => String }),
    Expose({ groups: ['login_email'] }),
    LengthWithLVS(8, 255, { always: true }),
    __metadata("design:type", String)
], AuthByEmailRequestDto.prototype, "password", void 0);
//# sourceMappingURL=AuthByEmailRequestDto.js.map